import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import customerFacingNotesReducer from 'modules/settings/quoteCreation/defaultNotes/customerFacingNotes/data/reducer';
import customerFacingNotesSaga, {
  initSaga as customerFacingNotesInitSaga,
} from 'modules/settings/quoteCreation/defaultNotes/customerFacingNotes/data/sagas';
import internalNotesReducer from 'modules/settings/quoteCreation/defaultNotes/internalNotes/data/reducer';
import internalNotesSaga from 'modules/settings/quoteCreation/defaultNotes/internalNotes/data/sagas';
import manufacturerNotesReducer from 'modules/settings/quoteCreation/defaultNotes/manufacturerNotes/data/reducer';
import manufacturerNotesSaga, {
  initSaga as manufacturerNotesInitSaga,
} from 'modules/settings/quoteCreation/defaultNotes/manufacturerNotes/data/sagas';
import fieldsReducer from 'modules/settings/quoteCreation/smartRfqSettings/data/reducer';
import fieldsSaga, {
  initSaga as fieldsInitSaga,
} from 'modules/settings/quoteCreation/smartRfqSettings/data/sagas';

const initSaga = function* () {
  yield all([
    fieldsInitSaga(),
    manufacturerNotesInitSaga(),
    customerFacingNotesInitSaga(),
  ]);
};

const reducer = combineReducers({
  fields: fieldsReducer,
  internalNotes: internalNotesReducer,
  manufacturerNotes: manufacturerNotesReducer,
  quoteNotes: customerFacingNotesReducer,
});

const saga = function* () {
  yield all([
    fieldsSaga(),
    internalNotesSaga(),
    manufacturerNotesSaga(),
    customerFacingNotesSaga(),
  ]);
};

export { initSaga, reducer, saga };
